import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'titleCase'})
export class TitleCasePipe implements PipeTransform {
    public transform(input: string): string {
        if (!input) {
            return '';
        } else {
            let capitalizedInput = input.replace(/\S+\s*/g, (txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase() ));
             const parts = capitalizedInput.split('-');
            // Capitalize the first letter of each part after the hyphen
            const capitalizedParts = parts.map(part => part.charAt(0).toUpperCase() + part.slice(1));
            // Join the parts back together with hyphens
            capitalizedInput = capitalizedParts.join('-');
            return capitalizedInput;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/common/pipes/title-case.pipe.ts